<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="name">Name</label>
        <input id="name" type="text" v-model="$parent.resort.resort_name">
      </div>

      <div>
        <label for="location">Location</label>
        <input id="location" type="text" v-model="$parent.resort.location">
      </div>

      <div>
        <label for="country">Country</label>
        <v-select
          v-model="$parent.resort.country"
          label="name"
          id="country"
          :options="countries"
          index="id"
        />
      </div>

    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'ResortFields',
  mounted() {
    this.getCountries();
  },
  data() {
    return {
      countries: []
    }
  },
  methods: {
    getCountries() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'countries', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.countries = response.data;
      })
    }
  }
}
</script>
